import { createSlice } from '@reduxjs/toolkit';

const getInitialBranding = () => {
  try {
    const cached = localStorage.getItem('branding_cache');
    if (!cached) {
      return DEFAULT_BRANDING;
    }
    const parsedCache = JSON.parse(cached);
    if (!parsedCache || typeof parsedCache !== 'object') {
      return DEFAULT_BRANDING;
    }
    return {
      ...DEFAULT_BRANDING,
      ...parsedCache,
      // An empty or null value in the cache never replaces the default logo or colour.
      logoUrl: parsedCache.logoUrl || DEFAULT_BRANDING.logoUrl,
      primaryColor: parsedCache.primaryColor || DEFAULT_BRANDING.primaryColor,
      brandingEnabled: parsedCache?.brandingEnabled === true,
      isSponsorsActive: Boolean(parsedCache?.isSponsorsActive),
      agentVisualizationConfig:
        parsedCache?.agentVisualizationConfig &&
        typeof parsedCache.agentVisualizationConfig === 'object'
          ? parsedCache.agentVisualizationConfig
          : null,
    };
  } catch {
    return DEFAULT_BRANDING;
  }
};
// Default Bridged branding (single source of truth for default primary color)
export const BRIDGED_LOGO = {
  light: '/company/logo_Black.png',
  dark: '/company/logo_White.png',
};

export function isBridgedDefaultLogo(url) {
  if (!url) return true;

  const normalized = String(url).split('?')[0];

  return normalized.endsWith(BRIDGED_LOGO.light) || normalized.endsWith(BRIDGED_LOGO.dark);
}

export function getSidebarLogoConfig({ brandingEnabled, logoUrl, isDarkTheme }) {
  const isClientLogo = Boolean(
    brandingEnabled === true && logoUrl && !isBridgedDefaultLogo(logoUrl)
  );

  return {
    src: isClientLogo ? logoUrl : isDarkTheme ? BRIDGED_LOGO.dark : BRIDGED_LOGO.light,
    isClientLogo,
  };
}

export const DEFAULT_BRANDING = {
  logoUrl: BRIDGED_LOGO.dark,
  primaryColor: '#753fd0',
  companyName: 'Bridged',
  subDomain: null,
  playBooksSubscribed: [],
  brandingEnabled: false,
  isSponsorsActive: false,
  agentVisualizationConfig: null,
};

const initialState = {
  branding: getInitialBranding(),
  loading: false,
  error: null,
  subdomain: null, // Current subdomain being used
};

export const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    setBrandingLoading: (state, action) => {
      state.loading = action.payload;
    },
    setBranding: (state, action) => {
      state.branding = action.payload;
      state.error = null;
    },
    setBrandingError: (state, action) => {
      state.error = action.payload;
      state.branding = DEFAULT_BRANDING;
    },
    setSubdomain: (state, action) => {
      state.subdomain = action.payload;
    },
    resetBranding: state => {
      state.branding = DEFAULT_BRANDING;
      state.subdomain = null;
      state.error = null;
    },
  },
});

export const { setBrandingLoading, setBranding, setBrandingError, setSubdomain, resetBranding } =
  brandingSlice.actions;

export default brandingSlice.reducer;
